const ProjectData = [
  {
    title: 'COOKGPT',
    description: 'CookGPT is an AI-driven culinary companion, offering personalized recipes, detailed cooking guides, and intuitive tools to make meal creation simple and enjoyable.',
    imageUrl: 'https://i.imgur.com/oClGuMg.jpeg',
    tech: ['NextJS', 'TypeScript', 'TailwindCSS'],
    seelivelink: 'https://www.cookgpt.io/',
    seesourcelink: 'https://github.com/binodbhusal/cookgpt-2.0',
    gallery: ['https://i.imgur.com/oClGuMg.jpeg', 'https://i.imgur.com/ZD8BYTY.jpeg', 'https://i.imgur.com/1d9V6AW.jpeg', 'https://i.imgur.com/18hMivt.jpeg', 'https://i.imgur.com/uBTfhp4.jpeg'],
    id: '3',
  },
  {
    title: 'ONBOOKING',
    description: 'OnBooking, an Airbnb-like platform, aims to offer a seamless experience in finding and booking accommodations.',
    imageUrl: 'https://i.imgur.com/jB76SHz.png',
    tech: ['Rails', 'JavaScript', 'TailwindCSS'],
    seelivelink: 'https://onbooking-production.up.railway.app/',
    seesourcelink: 'https://github.com/binodbhusal/onbooking',
    gallery: ['https://i.imgur.com/5DRMI2Q.png', 'https://i.imgur.com/hNSMECQ.png', 'https://i.imgur.com/CZFfo97.png', 'https://i.imgur.com/IR8F3Jr.png', 'https://i.imgur.com/s8FXY3n.png', 'https://i.imgur.com/NLpk6gj.png', 'https://i.imgur.com/Ms67x4L.png'],
    id: '1',
  },
  {
    title: 'BARATO',
    description: 'Barato is an innovative e-commerce platform by providing users with a seamless and interactive experience.',
    imageUrl: 'https://i.imgur.com/haQtodF.png',
    tech: ['React', 'Strapi', 'SCSS'],
    seelivelink: 'https://barato.netlify.app/',
    seesourcelink: 'https://github.com/binodbhusal/barato',
    gallery: ['https://i.imgur.com/haQtodF.png', 'https://i.imgur.com/uTvXDBg.png', ' https://i.imgur.com/8lNJoCQ.png', 'https://i.imgur.com/17loXix.png', 'https://i.imgur.com/LIbFhNr.png', 'https://i.imgur.com/vxEivfc.png'],
    id: '2',
  },

  {
    title: 'VR LANDING PAGE',
    description: 'VR Landing Page is an immersive VR landing page experience that introduces users to the world of virtual reality.',
    imageUrl: 'https://i.imgur.com/1bdazlk.png',
    tech: ['React', 'Tailwind CSS'],
    seelivelink: 'https://vrlandingpage.netlify.app/',
    seesourcelink: 'https://github.com/binodbhusal/vr-landing-page',
    gallery: ['https://i.imgur.com/1bdazlk.png', 'https://i.imgur.com/HAUSizu.png', 'https://i.imgur.com/tQyvYEs.png'],
    id: '4',
  },
  {
    title: 'CRYPTOFY',
    description: 'Web application that provides users with a comprehensive view of various cryptocurrency exchanges and their trading data.',
    imageUrl: 'https://i.imgur.com/tKiBGsK.png',
    tech: ['React & Redux', 'API Rest', 'ES6'],
    seelivelink: 'https://cryptofy.onrender.com/',
    seesourcelink: 'https://github.com/binodbhusal/cryptofy',
    gallery: ['https://i.imgur.com/5Ht8qzw.png', 'https://i.imgur.com/kZDmV4s.png'],
    id: '5',
  },
  // {
  //   title: 'BUDGET APP',
  //   description: 'Web-based personal finance
  // management application designed to help users
  // manage their finances effectively.It offers a
  // user-friendly interface to track income, expenses, and budget goals.',
  //   imageUrl: './assets/budgetappfinal.AVIF',
  //   tech: ['Rails', 'API', 'PostgreSQL'],
  //   seelivelink: 'https://mybudgetapp-qm8w.onrender.com/',
  //   seesourcelink: 'https://github.com/binodbhusal/BudgetApp',
  //   gallery: ['https://i.imgur.com/qgmTMgR.png', 'https://i.imgur.com/wVEbVhB.png', 'https://i.imgur.com/cnZbshz.png', 'https://i.imgur.com/xyjXEF5.png'],
  //   id: '6',
  // },

  {
    title: 'BLOG APP',
    description: 'BlogApp allows users to create personalized profiles where they can showcae their information, including a profile photo and breif bio.',
    imageUrl: 'https://i.imgur.com/ok2IAoP.png',
    tech: ['Rails', 'TailwindCSS'],
    seelivelink: 'https://blogapp-5efk.onrender.com',
    seesourcelink: 'https://github.com/binodbhusal/BlogApp',
    gallery: ['https://i.imgur.com/14JUkw4.png', 'https://i.imgur.com/p9VwQoF.png', 'https://i.imgur.com/sev9202.png', 'https://i.imgur.com/nwoD0IC.jpeg', 'https://i.imgur.com/iNtpJze.png'],
    id: '6',
  },
];
export default ProjectData;
